import { motion } from 'framer-motion';

const cards = [
  {
    title: 'MISIÓN',
    text: 'Crear un ambiente inclusivo y enriquecedor para todos nuestros alumnos, sin distinción de edad, sexo, religión, o cualquier otra índole, en donde se sientan valorados, inspirados y capacitados para formar músicos competentes que demuestren valores y cuenten con los suficientes recursos y capacidades que el medio demanda, siendo siempre innovadores y proactivos para con la industria musical, comprometidos con la cultura y el arte, así como con el mejoramiento personal y social.',
    color: '#007BFF',
  },
  {
    title: 'VISIÓN',
    text: 'Ser un referente internacional en la educación musical, reconocido por nuestra excelencia académica, nuestro compromiso con el bienestar emocional y el crecimiento personal de nuestros alumnos, maestros y colaboradores, así como por nuestra contribución continua al desarrollo cultural y artístico de la sociedad, siendo un pilar importante para demostrar que el arte es la llave para un mejor porvenir en donde la empatía, la sensibilidad y el amor sean un común denominador en las generaciones venideras.',
    color: '#8A2BE2',
  },
];

export default function MisionVision() {
  return (
    <section id="vision" className="bg-gray-50 py-24 px-4">
      <div className="max-w-6xl mx-auto">

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="text-center mb-16"
        >
          <p className="text-gray-400 uppercase tracking-[0.3em] text-xs mb-3">
            Nuestros valores
          </p>
          <h2 className="text-4xl md:text-5xl font-black text-black">
            Misión y Visión
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {cards.map((item, i) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="bg-white border border-gray-100 rounded-3xl p-10 shadow-sm"
            >
              <div
                className="w-12 h-1 rounded-full mb-6"
                style={{ backgroundColor: '#FFD700' }}
              />
              <h3 className="text-4xl font-black text-black mb-6">
                {item.title}
              </h3>
              <p className="text-gray-600 text-base leading-relaxed">{item.text}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
}
